<header [outlet]="introOutlet.isActivated && introOutlet.activatedRoute">
    <app-top-nav></app-top-nav>
    <app-intro>
        <router-outlet name="intro" #introOutlet="outlet"></router-outlet>
    </app-intro>
</header>
<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/components/main/app.component.html